export const UNIT_MIGRATION_STATUS = {
    PENDING: 'pending',
    FINISHED: 'finished',
} as const;

export type UnitMigrationStatus = typeof UNIT_MIGRATION_STATUS[keyof typeof UNIT_MIGRATION_STATUS];

export interface UnitMigrationSummary {
    unit_id: number;
    admin_unit_id: number;
    migration_status: UnitMigrationStatus | null;
    migration_config_loaded_at: Date | null;
    migration_date: Date | null;
    migrated_target_admin_unit_id: number | null;
}

export interface UnitResponse {
    type: 'unit';
    id: number;
    attributes: BaseUnitResponse;
}

/*******************************/
export interface UnitData {
    local_operations_manager: {
        id: number;
        first_name: string;
        last_name: string;
        display_name: string;
        email: string;
        phone: string;
    } | null;
    legacy_image_id: number | null;
    image_url?: string | null; // Direct image URL (used for PAL when URLs are provided directly)
}

export interface BaseUnitResponse {
    admin_unit_id: number;
    unit_code: string;
    country_code: string;
    city: string;
    state: string | null;
    unit_data: UnitData;
    admin_is_active: boolean;
    unit_name: string;
}

export interface UnitReviewSummary {
    admin_unit_id: number;
    summary: string;
    review_count: number;
    best_review_rating: number;
    best_review: string | null;
    best_review_id: string;
}

export interface UnitReviewSummaryOpenAiOutput {
    contains_inappropriate_content?: boolean;
    contains_personal_info?: boolean;
    contains_dates?: boolean;
    contains_controversial_info?: boolean;
    contains_negative_sentiment?: boolean;
    contains_specific_address_info?: boolean;
    positive_summary?: string;
    empty_summary_reason?: string;
    best_review_id?: number | string;
}

export interface UnitReviewRow {
    unitId: number;
    reviewId: number;
    displayReview: boolean;
    displayRating: boolean;
    overallRating: number;
    answer: string | null;
}
